import { Injectable } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { InHouseOrder, WebshopSettingsDataModel2, WebshopSettingsDMKey } from "../../shared/models";
import { IObjectObserver } from "../../services/IObjectObserver";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";
import { ContentType } from "../../shared/contentTypes";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { Observable } from "rxjs";

@Injectable()
export class OrderModeSelectorService {
  private _webshopSettingsObsServer: IObjectObserver<WebshopSettingsDataModel2>;

  constructor(objObsInjectHelper: CircularInjectionHelper
    , private _coreLogService: CoreLogService
  ) {
    const me = this;
    me._webshopSettingsObsServer = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(ContentType.WebshopSettings, objObsInjectHelper);
  }
  public get ObserveWebshopSettingsInHouseOrderChanges(): Observable<(string | number)[]> {
    return this._webshopSettingsObsServer.ObserveChanges;
  }

  public GetWebshopSettingsInHouseOrder(): Promise<InHouseOrder> {
    const me = this;
    return new Promise<InHouseOrder>((resolve, reject) => {
      me._webshopSettingsObsServer.GetObject(WebshopSettingsDMKey)
        .then((webshopSettings) => {
          resolve(webshopSettings.in_house_order);
        }).catch((error) => {
          me._coreLogService.error("InHauseServiceSelectorService.GetWebshopSettingsInHouseOrder", "GetObject", error);
          reject();
        });
    });
  }
}